import type { Doctor } from '../booking/types/booking.type'

// More fields than this read as a list rather than a qualification, so the line is left out.
const MAX_FIELDS_SHOWN = 3

/**
 * A doctor's fields of specialisation as one line, or nothing when there are none or too many to
 * read as a qualification.
 */
function formatFieldOfSpecialisations(fields: Doctor['fieldOfSpecialisations']): string | undefined {
  if (!fields || fields.length === 0 || fields.length > MAX_FIELDS_SHOWN) {
    return undefined
  }

  return fields.map((field) => field.display || field.name).join(', ')
}

export { formatFieldOfSpecialisations }
